import { Component, OnInit } from '@angular/core';
import { BaseTabsUpdateComponent, TabsContainerService, BaseDataService, UserService, ModalService, BaseUpdateComponent, QueryParameter, ModelDataService } from 'yt-ng-framework';
import { ActivatedRoute, Router } from '@angular/router';
import { OrgJed } from 'src/app/lookups/orgjed/orgjed';

@Component({
  selector: 'app-sist-radnih-mesta-tab-update',
  templateUrl: './sist-radnih-mesta-tab-update.component.html'
})
export class SistRadnihMestaTabUpdateComponent 
extends BaseTabsUpdateComponent<OrgJed> 
implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected tabsContainerService: TabsContainerService<OrgJed>,
    protected baseDataService: BaseDataService,
    protected userService: UserService,
    protected modalService: ModalService,
    protected modelDataService: ModelDataService,
    protected router: Router
  ) { 
    super(activatedRoute, tabsContainerService, baseDataService, userService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
